import {
  Box,
  Button,
  Container,
  Heading,
  SimpleGrid,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FiInbox } from 'react-icons/fi';
import { useMyClaims } from '../../hooks/useClaims';
import { useAuth } from '../../contexts/AuthContext';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { EmptyState } from '../common/EmptyState';
import { ClaimCard } from './ClaimCard';

const STATUS_GROUPS = {
  active: ['pending', 'under_review', 'disputed'],
  approved: ['approved'],
  rejected: ['rejected'],
};

export default function MyClaims() {
  const { currentUser } = useAuth();
  const { claims, loading } = useMyClaims(currentUser?.uid);

  const grouped = {
    active: claims.filter((c) => STATUS_GROUPS.active.includes(c.status)),
    approved: claims.filter((c) => STATUS_GROUPS.approved.includes(c.status)),
    rejected: claims.filter((c) => STATUS_GROUPS.rejected.includes(c.status)),
  };

  return (
    <Container maxW="7xl" py={6} px={0}>
      <VStack spacing={6} align="stretch">
        <Box>
          <Heading size="lg">My Submissions</Heading>
          <Text color="gray.600" mt={1}>
            {loading ? '' : `${claims.length} total submission${claims.length !== 1 ? 's' : ''} submitted`}
          </Text>
        </Box>

        {loading ? (
          <LoadingSpinner message="Loading your submissions..." />
        ) : claims.length === 0 ? (
          <VStack spacing={4}>
            <EmptyState
              title="No submissions yet"
              description="Browse tasks and submit your research to earn rewards"
              icon={FiInbox}
            />
            <Button as={Link} to="/tasks" colorScheme="orange">
              Browse Tasks
            </Button>
          </VStack>
        ) : (
          <Tabs colorScheme="orange">
            <TabList>
              <Tab>Pending ({grouped.active.length})</Tab>
              <Tab>Approved ({grouped.approved.length})</Tab>
              <Tab>Rejected ({grouped.rejected.length})</Tab>
            </TabList>
            <TabPanels>
              <TabPanel px={0}>
                {grouped.active.length === 0 ? (
                  <EmptyState title="No pending submissions" icon={FiInbox} />
                ) : (
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={5} mt={4}>
                    {grouped.active.map((claim) => (
                      <ClaimCard key={claim.id} claim={claim} />
                    ))}
                  </SimpleGrid>
                )}
              </TabPanel>
              <TabPanel px={0}>
                {grouped.approved.length === 0 ? (
                  <EmptyState title="No approved submissions" icon={FiInbox} />
                ) : (
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={5} mt={4}>
                    {grouped.approved.map((claim) => (
                      <ClaimCard key={claim.id} claim={claim} />
                    ))}
                  </SimpleGrid>
                )}
              </TabPanel>
              <TabPanel px={0}>
                {grouped.rejected.length === 0 ? (
                  <EmptyState title="No rejected submissions" icon={FiInbox} />
                ) : (
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={5} mt={4}>
                    {grouped.rejected.map((claim) => (
                      <ClaimCard key={claim.id} claim={claim} />
                    ))}
                  </SimpleGrid>
                )}
              </TabPanel>
            </TabPanels>
          </Tabs>
        )}
      </VStack>
    </Container>
  );
}
